// extracted by mini-css-extract-plugin
export default {"moveCubuk":"X1sYuvg5SHFocplhmE_n"};